interface DisplayRowProps {
  label: string
  /** Prevent browser auto-translation of the value (proper nouns like names). */
  noTranslate?: boolean
  sublabel?: string
  value: null | string | undefined
}

export function DisplayRow({ label, noTranslate, sublabel, value }: DisplayRowProps) {
  return (
    <div className="flex gap-6 py-2">
      <div className="w-32 shrink-0 sm:w-48">
        <span className="text-sm font-semibold text-gray-light-700">{label}</span>
        {sublabel && <span className="block text-xs text-gray-light-500">{sublabel}</span>}
      </div>
      <span
        className="min-w-0 text-sm break-all text-gray-light-900"
        translate={noTranslate ? 'no' : undefined}
      >
        {value || 'Non renseigné(e)'}
      </span>
    </div>
  )
}
